// @flow
import getNotificationCounts from '../../notifications/api/getNotificationCounts';

const BACKOFF_INTERVALS_MS = [60000, 90000, 180000, 300000];

let subscribers: Set<(count: number) => void> = new Set();
let timeoutId = null;
let backoffIndex = 0;
let prevCount = null;

async function poll() {
    const response = await getNotificationCounts();
    const count = response ? response.countMessagingNotViewed : 0;

    if (count === prevCount) {
        backoffIndex = Math.min(
            backoffIndex + 1,
            BACKOFF_INTERVALS_MS.length - 1
        );
    } else {
        backoffIndex = 0;
    }
    prevCount = count;

    subscribers.forEach((cb: (count: number) => void) => cb(count));

    if (subscribers.size > 0) {
        timeoutId = setTimeout(poll, BACKOFF_INTERVALS_MS[backoffIndex]);
    }
}

export function subscribe(callback: (count: number) => void): () => void {
    subscribers.add(callback);
    if (subscribers.size === 1) {
        poll();
    }
    return () => {
        subscribers.delete(callback);
        if (subscribers.size === 0) {
            clearTimeout(timeoutId);
            timeoutId = null;
            backoffIndex = 0;
            prevCount = null;
        }
    };
}
